export enum CollectiveDmsTimelineVariant {
  DEFAULT = 'DEFAULT',
  LITE = 'LITE',
}
